<ng-template #loadingModal let-modal>
  <app-loader [loaderStyle]="{height: '100%'}"></app-loader>
</ng-template>

<ng-template #confirmModal let-modal>
    <div class="modal-header justify-content-center">
        <h3 class="fw-semibold">Xác nhận thông tin</h3>
        <app-button [class]="'btn btn-close btn-sm'" [spinner]="false" [id]="'login_modal_close_btn'"
            (click)="onClose()">
            <i class="ri-close-line"></i>
        </app-button>
    </div>
    <div class="p-3">
        <form [formGroup]="form" (ngSubmit)="onConfirm()">
            <div class="d-grid gap-4">
                <h3 class="fw-bold">
                    Giấy chứng nhận đạt thực hành tốt phân phối thuốc, nguyên liệu làm thuốc (GPP)
                </h3>
                <div class="d-flex row">
                    <div class="col-xxl-4 col-lg-4 col-md-4 col-sm-4 pb-2">
                        <div class="form-floating">
                            <input type="text" class="form-control" id="distributionCertificationsNo3"
                                formControlName="distributionCertificationsNo" />
                            <label for="distributionCertificationsNo3">
                                Số giấy phép
                            </label>
                        </div>
                        <label *ngIf="form.controls['distributionCertificationsNo'].touched && form.controls['distributionCertificationsNo'].errors?.['required']"
                            class="invalid-feedback">
                            Nhập Số giấy phép
                        </label>
                    </div>
                    <div class="col-xxl-4 col-lg-4 col-md-4 col-sm-4 pb-2">
                        <div class="form-floating">
                            <input class="form-control" placeholder="Ngày cấp" name="dp3"
                                style="width: -webkit-fill-available;" id="distributionCertificationsDate3" formControlName="distributionCertificationsDate"
                                readonly ngbDatepicker #ds3="ngbDatepicker" (click)="ds3.toggle()" />
                            <label class="date-picker-label" for="distributionCertificationsDate3">
                                Ngày cấp
                            </label>
                        </div>
                        <label *ngIf="form.controls['distributionCertificationsDate'].touched && form.controls['distributionCertificationsDate'].errors?.['required']"
                            class="invalid-feedback">
                            Nhập Ngày cấp
                        </label>
                    </div>
                    <div class="col-xxl-4 col-lg-4 col-md-4 col-sm-4 pb-2">
                        <div class="form-floating">
                            <input class="form-control" placeholder="Ngày cấp" name="dp4"
                                style="width: -webkit-fill-available;" id="distributionCertificationsExpirationDate3"
                                formControlName="distributionCertificationsExpirationDate" readonly ngbDatepicker
                                #ds4="ngbDatepicker" (click)="ds4.toggle()" />
                            <label class="date-picker-label" for="distributionCertificationsExpirationDate3">
                                Ngày hết hạn
                            </label>
                        </div>
                        <label *ngIf="form.controls['distributionCertificationsExpirationDate'].touched && form.controls['distributionCertificationsExpirationDate'].errors?.['required']"
                            class="invalid-feedback">
                            Nhập Ngày hết hạn
                        </label>
                    </div>
                </div>
                <div class="d-flex row">
                    <div class="col-12 pb-2">
                        <div class="form-floating">
                            <textarea type="text" class="form-control" style="height: auto; resize: none;" id="distributionCertificationsProvince3"
                                formControlName="distributionCertificationsProvince" rows="2"></textarea>
                            <label for="distributionCertificationsProvince3">
                                Nơi cấp
                            </label>
                        </div>
                        <label *ngIf="form.controls['distributionCertificationsProvince'].touched && form.controls['distributionCertificationsProvince'].errors?.['required']"
                            class="invalid-feedback">
                            Nhập Nơi cấp
                        </label>
                    </div>
                </div>
            </div>
            <div class="pt-3">
                <h3 class="fw-bold">
                    Danh mục sản phẩm được phép kinh doanh
                </h3>
                <div class="row row-cols-2 row-cols-lg-2 row-cols-md-3 row-cols-xl-3 row-cols-xxl-4 g-3 g-sm-4 pt-3">
                    <div *ngFor="let scope of scopes" class="d-flex align-items-center" style="opacity: 0.6;">
                        <input class="checkbox_animated" type="checkbox" id="category-{{scope.code}}"
                            [checked]="scope.checked" disabled readonly
                            (keyup)="$event.preventDefault()"
                            (keypress)="$event.preventDefault()"
                            (keydown)="$event.preventDefault()"
                            (paste)="$event.preventDefault()"
                            (copy)="$event.preventDefault()"
                            (cut)="$event.preventDefault()" />
                        <label class="form-check-label" for="category-{{scope.code}}">
                            <span class="name">{{ scope.name }}</span>
                        </label>
                    </div>
                </div>
            </div>

            <div>
                <button type="submit" class="btn w-100 mt-3" style="background-color: var(--theme-color); color: #fff;"
                    [disabled]="form.invalid">
                    Xác nhận
                </button>
            </div>
        </form>
    </div>
</ng-template>